import React from 'react';
import { formatAmount } from '../../../lair/utils/missionMath';
import { missionName, rewardIcon, rewardName } from '../../../lair/utils/lairAssets';
import { useTranslation } from 'react-i18next';
import LifeLost from '../../common/LifeLost';
import { formatNumber } from '../../../../i18n/format';

/** Final overlay: stars, score and rewards from the MissionRunDTO (same reward rendering as Tactics). */
export default function Match3EndScreen({ result, stars = 0, score = 0, target = 0, run, timedOut, onBack }) {
  const { t } = useTranslation();
  const win = result === 'WIN';
  const rewards = run?.rewards || [];
  const s = Math.max(0, Math.min(3, stars || 0));
  let headline = win ? t('match3.end.cleared', 'MINE CLEARED') : t('match3.end.out_of_moves', 'OUT OF MOVES');
  if (timedOut) headline = t('game.end.times_up', "TIME'S UP");

  return (
    <div className={`m3-end ${win ? 'm3-end--win' : 'm3-end--lose'}`} role="dialog" aria-label={t('game.end.aria', 'Game result')} data-testid="end-screen">
      <div className="m3-end__card">
        <div className="m3-end__glow" />
        <div className="m3-end__headline">{headline}</div>
        {run?.missionName && <div className="m3-end__mission">{missionName(run, t)}</div>}
        <div className="m3-end__stars" aria-label={t('game.end.stars_aria', '{{n}} of 3 stars', { n: s })} data-testid="end-stars">
          {[0, 1, 2].map((i) => (
            <span key={i} className={`m3-end__star ${i < s ? 'is-on' : ''}`} style={{ animationDelay: `${0.25 + i * 0.2}s` }}>
              {i < s ? '★' : '☆'}
            </span>
          ))}
        </div>
        <div className="m3-end__score" data-testid="end-score">
          {formatNumber(Number(score))} <span>/ {formatNumber(Number(target))}</span>
        </div>
        <div className="m3-end__sub">
          {win
            ? (s >= 3 ? t('match3.end.legendary', 'A legendary haul!') : t('match3.end.vein', 'The vein is yours'))
            : (rewards.length
              ? t('match3.end.part_loot', 'Your hero carried out a part of the loot')
              : t('game.end.empty_handed', 'Your hero left empty-handed'))}
        </div>

        {rewards.length > 0 ? (
          <div className="m3-end__rewards" data-testid="end-rewards">
            {rewards.map((r, i) => {
              const icon = rewardIcon(r);
              return (
                <div key={`${r.rewardType}-${r.resourceCode || r.moduleId || ''}-${i}`} className="m3-reward">
                  <div className="m3-reward__icon">{icon ? <img src={icon} alt="" /> : <span>?</span>}</div>
                  <span className="m3-reward__name">{rewardName(r, t)}</span>
                  <span className="m3-reward__val">+{formatAmount(r.amount)}</span>
                </div>
              );
            })}
          </div>
        ) : (
          !run && <div className="m3-end__sub m3-end__sub--dim">{t('game.end.delivering', 'Rewards are being delivered…')}</div>
        )}

        {!win && <div><LifeLost /></div>}

        <button type="button" className="app-btn app-btn--green m3-end__btn" onClick={onBack}>
          {t('mission.back_to_lair', 'Back to Lair')}
        </button>
      </div>
    </div>
  );
}
